if account
    if account.logoUrl
        img(src=account.logoUrl, height='35')
else
    a.btn.dashed.add-logo Upload your logo
